import Utils from '../utils';
import SubNavigationLayout from '../navigation/SubNavigationLayout';
import './SearchNavigation.scss';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { decodeSqureBrackets } from './utils/mappers';

type Props = {
    readonly isSticky: boolean;
};

const SearchNavigation = ({ isSticky }: Props) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const q = searchParams.get('q');
    const searchLabel = searchParams.get('searchLabel');
    const searchTerm = decodeSqureBrackets(searchLabel ?? q ?? '');

    return (
        <SubNavigationLayout
            left={
                <ul className="search-nav">
                    <li>
                        <i className="material-icons big">search</i>
                        {t('components.searchResults.searchResults')}
                    </li>
                    <li>
                        <i className="material-icons big">keyboard_arrow_right</i>
                    </li>
                    <li>{Utils.truncate(searchTerm, { length: 120 })}</li>
                </ul>
            }
            isSticky={isSticky}
            width="50"
        />
    );
};

export default SearchNavigation;
